<modal-component>
	
	<!-- LEFT-->
	<ng-container left>
		<div class="_header">
			<p class="_title" [translate]="'CLIENT.CREATE'"></p>
			<p class="_subtitle">{{clientForm?.get('firstname').value}} {{clientForm?.get('lastname').value}}</p>
		</div>
	</ng-container>

	<!-- RIGHT -->
	<ng-container right>	
		<form-client *ngIf="clientForm" [formGroup]="clientForm" [edit]="true"></form-client>
	</ng-container>

	<!-- BUTTONS -->
	<ng-container buttons>
		<button (click)="create()" class="_button _add-button">
			<span [translate]="'CLIENT.CREATE'"></span>
		</button>
    </ng-container>

</modal-component>